export const setAuth = (token, user) => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
  
  // Dispatch custom event to notify same-tab components of auth change
  window.dispatchEvent(new CustomEvent('authChange', { detail: { token, user } }));
};

export const getToken = () => localStorage.getItem('token');

export const getUser = () => {
  const userStr = localStorage.getItem('user');
  console.log('🔐 getUser: localStorage user string:', userStr);
  const user = userStr ? JSON.parse(userStr) : null;
  console.log('🔐 getUser: parsed user:', user);
  return user;
};

export const clearAuth = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  
  // Dispatch custom event to notify same-tab components of logout
  window.dispatchEvent(new CustomEvent('authChange', { detail: { token: null, user: null } }));
};

export const isLoggedIn = () => !!getToken();
